import { FC } from 'react';
import { Step } from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { TourGuide } from '../../../../components';
import { useAppDispatch } from '../../../../hooks/useAppStore';
import { commonActions } from '../../../../store/common/slice';

type TSheetsCardTour = {
  runTour: boolean
  setRunTour: (val: boolean) => void
};

const SheetsCardTour: FC<TSheetsCardTour> = ({ runTour, setRunTour }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('tour');

  const tourSteps: Array<Step> = [
    {
      target: '#add-shift',
      disableBeacon: true,
      content: t('thisButtonAllowsYouToAddAShift'),
    },
    {
      target: '#start-date',
      disableBeacon: true,
      content: t('selectTheStartDateForTheShift'),
    },
    {
      target: '#end-date',
      disableBeacon: true,
      content: t('thisPickerDependsOnTheStartDate'),
    },
    {
      target: '#start-time',
      disableBeacon: true,
      content: t('selectTheStartTimeForTheShift'),
    },
    {
      target: '#end-time',
      disableBeacon: true,
      content: t('selectTheEndTimeForTheShift'),
    },
    {
      target: '#time-location',
      disableBeacon: true,
      content: t('selectTheLocationForWhich'),
    },
    {
      target: '#add-break',
      disableBeacon: true,
      content: t('useThisOptionToAddBreaks'),
    },
    {
      target: '#submit-shift',
      disableBeacon: true,
      content: t('clickThisButtonToSubmit'),
    },
  ];

  const handleFinishTour = () => {
    setRunTour(false);
    dispatch(commonActions.setIsOpenPagesNav(false));
  };

  return (
    <TourGuide steps={tourSteps} run={runTour} onFinish={handleFinishTour} />
  );
};

export {
  SheetsCardTour,
};
